export default {
    view: {
        success: {
            header: "Pesquisa enviada",
            message: "Obrigado pelo seu feedback."
        },
        productChoice: {
            cta: "Salve",
            processing: "Salvando"
        },
        addressForm: {
            cta: "Salve",
            processing: "Salvando"
        }
    },
    delivery: {
        title: "Pesquisa de entrega",
        message: "Você recebeu todos os itens listados abaixo?",
        cta: {
            yes: "Sim",
            no: "Não",
            processing: "Salvando"
        }
    }
}